export enum SettingsPermissionsDataEventObjectsEnum {
  PERMISSION_EDIT = 'permission_edit',
}
